<template>
    <div class="wrapper">
        <the-header></the-header>
        <div class="content">
            <router-view></router-view>
        </div>
        <!-- <the-footer></the-footer> -->
    </div>
</template>

<script>
import TheHeader from '@/components/header/TheHeader';
import TheFooter from '@/components/TheFooter';
export default {
    name: "Home",
    components: {
        TheHeader,
        TheFooter 
    },
    created() {
        localStorage.removeItem("residenceBread");
        localStorage.removeItem("residenceLevel");
    }
};
</script>
<style scoped>
.wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    flex: auto;
    position: relative;
}
.content {
    flex: auto;
}
</style>


